import { render } from "./UpdatesCard.vue?vue&type=template&id=16f73a7a&scoped=true&ts=true"
import script from "./UpdatesCard.vue?vue&type=script&lang=ts"
export * from "./UpdatesCard.vue?vue&type=script&lang=ts"

import "./UpdatesCard.vue?vue&type=style&index=0&id=16f73a7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f73a7a"]])

export default __exports__